import { ParagraphSizes } from "atoms/constants/paragraph-sizes";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import useCurrentIdentity from "utilities/hooks/use-current-identity";
import ProfileMenu from "./profile-menu";
import { t } from "utilities/localization-utils";
import LogInAnchor from "molecules/log-in-anchor/log-in-anchor";
import PlansAnchor from "molecules/plans-anchor/plans-anchor";
import { ButtonStyles } from "atoms/constants/button-styles";

const BASE_CLASS = "c-profile-or-unauthenticated-menu";

const ProfileOrUnauthenticatedMenu = () => {
    const { isLoggedIn, currentIdentity } = useCurrentIdentity();

    return (
        <div className={BASE_CLASS}>
            {isLoggedIn ? (
                <div className={`${BASE_CLASS}__profile`}>
                    <Paragraph
                        cssClassName={`${BASE_CLASS}__name`}
                        size={ParagraphSizes.Small}>
                        <span data-test-id={"signed-in-as"}>
                            {`${t("signedInAs")} `}
                        </span>
                        <strong data-test-id={"signed-in-user-name"}>
                            {currentIdentity?.user?.getFirstAndLastName()}
                        </strong>
                    </Paragraph>
                    <div className={`${BASE_CLASS}__profileMenu`}>
                        <ProfileMenu hideActions={true} />
                    </div>
                </div>
            ) : (
                <div className={`${BASE_CLASS}__buttonGroup`}>
                    <LogInAnchor
                        style={ButtonStyles.Secondary}
                        cssClassName={`${BASE_CLASS}__button`}
                    />
                    <PlansAnchor
                        cssClassName={`${BASE_CLASS}__button c-button -primary`}
                    />
                </div>
            )}
        </div>
    );
};

export default ProfileOrUnauthenticatedMenu;
